var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import StyleBase from "../../common/styleBase";
var ComponentStyles = /** @class */ (function (_super) {
    __extends(ComponentStyles, _super);
    function ComponentStyles() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.componentStylesBase = {
            container: {
                backgroundColor: "#202020",
                borderLeft: 0,
                borderBottom: 0,
                borderTop: 0,
                borderRight: "1px solid #353535",
                borderStyle: "solid",
                display: "flex",
                flexDirection: "column",
                flexShrink: 0,
                maxWidth: "15rem",
                width: "15rem",
            },
            navContainer: {
                flex: 1,
            },
            navigationStyles: {
                root: {
                    flex: 1,
                },
                navItem: {
                // height: "35%",
                },
                link: {
                    color: "#dedede",
                    fontFamily: "Verdana, Geneva, sans-serif",
                    fontSize: "0.78rem",
                    fontWeight: 600,
                    height: "42px",
                    letterSpacing: "0",
                    lineHeight: "42px",
                    paddingLeft: "1.5rem",
                },
                chevronButton: {
                    height: "35px",
                    lineHeight: "35px",
                },
                chevronIcon: {
                    height: "35px",
                    lineHeight: "35px",
                },
            },
            moreTools: {
                color: "#a3a3a3",
                display: "grid",
                fontFamily: "Verdana, Geneva, sans-serif",
                fontSize: "0.72rem",
                lineHeight: "1.5",
                margin: "0 1.5rem 1.5rem",
                textAlign: "center",
            },
        };
        _this.componentStylesSmallDevice = __assign(__assign({}, _this.componentStylesBase), { container: __assign(__assign({}, _this.componentStylesBase.container), { top: "4.5rem", bottom: 0, left: 0, overflowY: "auto", position: "fixed", zIndex: 99 }) });
        return _this;
    }
    return ComponentStyles;
}(StyleBase));
export default ComponentStyles;
